import { SwitchInlineEditor } from 'components/inline_edit/ToggleInlineEditor';
import { usePermissions } from 'contexts/PermissionsContext';
import { UsersTableCellProps } from 'pages/Settings/Users/UsersTable';
import { updateUser } from 'utils/user';

export function UserApprovedCell({ rowData, onChange }: UsersTableCellProps) {
    const { canEditUserProperties } = usePermissions();
    const onSave = async (newValue: boolean | undefined) => {
        if (newValue === undefined) {
            throw new Error('Attempted to save without approval value');
        }
        try {
            await updateUser(rowData.Id, {
                IsApproved: newValue,
            });
            onChange();
        } catch {
            return 'Unable to save setting for approval value';
        }
        return undefined;
    };

    return (
        <SwitchInlineEditor
            onConfirm={onSave}
            value={rowData.IsApproved}
            isDisabled={!canEditUserProperties}
        />
    );
}
